import {
    IAdminDashboardSummary,
    IDashboardFilters,
} from '../../protocolos';

import { Api } from '../api/axios-config';

const buildQueryParams = (filters?: IDashboardFilters): string => {
    const params = new URLSearchParams();

    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);

    const query = params.toString();

    return query ? `?${query}` : '';
};

const getAdminSummary = async (
    filters?: IDashboardFilters,
): Promise<IAdminDashboardSummary | Error> => {
    try {
        const { data } = await Api.get(
            `/dashboard/admin/summary${buildQueryParams(filters)}`,
        );

        if (data) return data;

        return new Error('Erro ao carregar o dashboard administrativo.');
    } catch (error) {
        console.error(error);
        return new Error(
            (error as { message: string }).message ||
            'Erro ao carregar o dashboard administrativo.',
        );
    }
};

export const DashboardService = {
    getAdminSummary,
};